module.exports = __webpack_public_path__ + "static/media/bg.754fcbf9.jpg";